import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(1)
    },
    fileUploadArea: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  })
);
